import HeaderBlock from "../ui/blocks/HeaderBlock";
import ImageBlock from "../ui/blocks/ImageBlock";
import ParagraphBlock from "../ui/blocks/ParagraphBlock";
import CatalogCardBlock from "../ui/blocks/CatalogCardBlock";
import ListBlock from "../ui/blocks/ListBlock";
import DelimiterBlock from "../ui/blocks/DelimiterBlock";
import TableBlock from "../ui/blocks/TableBlock";

export const BLOCK_REGISTRY = {
    header: HeaderBlock,
    image: ImageBlock,
    paragraph: ParagraphBlock,
    catalogCard: CatalogCardBlock,
    list: ListBlock,
    delimiter: DelimiterBlock,
    table: TableBlock,
};
